// extracted by mini-css-extract-plugin
export default {"voidConfirmationModal":"styles_voidConfirmationModal__SiSCM","icon":"styles_icon__xVJxJ","voidConfirmationContent":"styles_voidConfirmationContent__kTgFw"};